import React, { useState } from "react";
import { documents } from "../Documents";
import { HiChevronDown } from "react-icons/hi";
import { FiArrowLeft, FiDownload, FiShield } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function Terms() {
  const reportDocuments = documents.filter((doc) => doc.reports === false);
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-[1080px] mx-auto px-4 py-28 md:py-36 w-full">
      <div className="mb-8">
        <Link
          to="/"
          className="inline-flex items-center space-x-2 text-xs font-bold uppercase tracking-wider text-slate-500 hover:text-brandRed transition-colors px-3 py-2 rounded-xl bg-slate-50 hover:bg-red-50 border border-slate-200"
        >
          <FiArrowLeft size={14} />
          <span>Վերադառնալ Գլխավոր Էջ</span>
        </Link>
      </div>

      <div className="text-center max-w-xl mx-auto mb-12">
        <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full bg-red-50 text-brandRed text-xs font-bold uppercase tracking-wider mb-2">
          <FiShield size={13} />
          <span>Պաշտոնական Կանոնակարգեր</span>
        </div>
        <h1 className="text-3xl md:text-5xl font-black text-slate-900 uppercase tracking-tight">
          Պայմաններ և Դրույթներ
        </h1>
        <p className="text-slate-500 text-sm mt-2">
          «Ռեալ Թայմ» ՍՊԸ ծառայությունների մատուցման ընդհանուր դրույթներ և պայմանագրային պայմաններ
        </p>
      </div>

      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
        {reportDocuments.map((doc, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={index}
              className="bg-white border border-slate-200/80 rounded-3xl overflow-hidden shadow-premium"
            >
              {/* Header */}
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left font-bold text-slate-900 hover:bg-slate-50/70 transition-colors focus:outline-none"
              >
                <span className="text-sm md:text-base font-extrabold uppercase tracking-wide">
                  {doc.title}
                </span>
                <HiChevronDown
                  className={`text-xl text-slate-400 transition-transform duration-300 ${
                    isOpen ? "transform rotate-180 text-brandRed" : ""
                  }`}
                />
              </button>

              {/* Body */}
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  isOpen
                    ? "max-h-[800px] opacity-100 p-5 md:p-6 pt-0 border-t border-slate-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="space-y-2.5 pt-4">
                  {doc.documents.map((file, fileIndex) => (
                    <div
                      key={fileIndex}
                      className="flex items-center justify-between p-2.5 rounded-xl hover:bg-slate-50 border border-transparent hover:border-slate-100 transition-all"
                    >
                      <span className="text-xs font-medium text-slate-700">
                        {file.title}
                      </span>
                      <a
                        href={file.file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center space-x-1.5 text-xs font-bold text-brandRed hover:text-brandRedHover bg-red-50 hover:bg-red-100 px-3 py-1.5 rounded-lg transition-colors"
                      >
                        <FiDownload size={13} />
                        <span>PDF</span>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
